<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <v-form ref="editForm" v-model="isProfileFormValid">
        <div class="page-title">
          <a v-if="isAdminOrBenefactor" @click.stop="goToAgentManagement"
            ><v-icon class="mr-3">fal fa-arrow-left</v-icon></a
          >
          <h1>Meu Perfil</h1>
        </div>
        <v-container>
          <!-- Card-1 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container>
                <span class="list-labels">Dados básicos</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-4">
                    <span class="avatar p-relative">
                      <!-- <v-btn color="var(--feature)" fab depressed>
                                                <v-icon class="white--text">fal fa-camera</v-icon>
                                            </v-btn> -->
                      <v-avatar size="150" color="var(--gray-light)">
                        <img
                          v-if="profileData && profileData.personViewModel"
                          :src="
                            `https://ui-avatars.com/api/?name=${profileData.personViewModel.fullName}&size=160`
                          "
                        />
                      </v-avatar>
                    </span>
                  </v-col>
                  <!-- form ###################################### -->
                  <v-col class="flex-grow-1">
                    <v-container fluid pa-0>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Nome Completo"
                            outlined
                            hide-details="auto"
                            required
                            v-model="fullName"
                            :rules="[validatefullName]"
                            :disabled="edit || isBenefactor"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-mask="['###.###.###-##']"
                            label="CPF"
                            outlined
                            hide-details="auto"
                            required
                            v-model="document"
                            :rules="[validatedocument]"
                            :disabled="edit || isBenefactor"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            label="Celular"
                            outlined
                            hide-details="auto"
                            required
                            v-model="phone"
                            :rules="[validatephone]"
                            :disabled="edit"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            label="E-mail"
                            outlined
                            hide-details="auto"
                            required
                            v-model="email"
                            :rules="[validateEmail]"
                            :disabled="edit"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select
                            label="Genêro"
                            outlined
                            hide-details="auto"
                            required
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="8" md="3">
                          <ChangePasswordCard v-if="!isBenefactor" />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- form address ###################################### -->
        <AddressForm
          :registeredAddress="address"
          @newdata="handleData($event)"
          v-if="!isBenefactor"
        />

        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn
                v-if="isAdminOrBenefactor"
                @click="goToAgentManagement()"
                color="secondary"
                rounded
                large
                depressed
                class="px-12 mr-1 white--text footer-border-left"
                >Voltar</v-btn
              >
              <v-btn
                color="secondary"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-left"
                :v-show="!edit"
                :disabled="!isProfileFormValid"
                @click="goToPreviousPage()"
                >Voltar</v-btn
              >
              <v-btn
                color="info"
                rounded
                large
                depressed
                class="px-12 ml-1 footer-border-right"
                :v-show="!edit"
                :disabled="!isProfileFormValid"
                @click="editProfile()"
                >Salvar</v-btn
              >
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>

    <!-- crud message dialog ###################################### -->
    <CrudMessageResponse
      :showMessage="showeditMessage"
      :message="editMessage"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NavBar from "@/components/NavBar";
import AuthService from "@/scripts/services/auth.service";
import GeneralService from "@/scripts/services/general.service";
import CommonHelper from "@/scripts/helpers/common.helper";
import ChangePasswordCard from "@/components/ChangePassword";
import AddressForm from "@/components/AddressForm";
import Routes from "@/router/names.js";

export default {
  name: "New",
  components: {
    NavBar,
    ChangePasswordCard,
    AddressForm
  },
  data: () => ({
    isFormValid: false,
    authService: new AuthService(),
    generalService: new GeneralService(),

    //Dialog controls
    showChangePassword: false,
    isProfileFormValid: false,

    // Profile Data Control
    edit: false,
    isBenefactor: false,
    showeditMessage: false,
    editMessage: "",
    profileData: {},

    //Profile Information
    document: "",
    fullName: "",
    phone: "",
    email: "",
    password: "",

    address: {}
  }),
  computed: {
    ...mapGetters(["selectedAgent"]),
    ...mapGetters("userModule", ["isAdminOrBenefactor"])
  },
  mounted() {
    this.GoToCorrectPath();
  },
  created() {
    this.generalService
      .listAllStates()
      .then(result => (this.stateList = result));
  },
  watch: {
    "$route.path": function() {
      this.GoToCorrectPath();
    }
  },
  methods: {
    ...mapActions(["setSelectedAgent"]),
    GoToCorrectPath() {
      if (
        this.$route.params.agentId &&
        this.selectedAgent &&
        this.selectedAgent.id == this.$route.params.agentId
      ) {
        this.profileData = this.selectedAgent;

        this.email = this.profileData.email;
        this.document = this.profileData.personViewModel.document;
        this.fullName = this.profileData.personViewModel.fullName;
        this.phone = this.profileData.personViewModel.phone;
        this.address = {
          GoogleAddress: this.profileData.personViewModel.addressViewModel
            .googleAddress,
          PostalCode: this.profileData.personViewModel.addressViewModel
            .postalCode,
          Neighborhood: this.profileData.personViewModel.addressViewModel
            .neighborhood,
          Street: this.profileData.personViewModel.addressViewModel.street,
          Number: this.profileData.personViewModel.addressViewModel.number,
          Complement: this.profileData.personViewModel.addressViewModel
            .complement,
          City: this.profileData.personViewModel.addressViewModel.city,
          State: this.profileData.personViewModel.addressViewModel.state
        };

        this.isBenefactor = true;
      } else {
        this.isBenefactor = false;
        this.loadProfile();
      }
    },
    editProfile() {
      let profile = {
        email: this.email,
        password: this.password,
        active: true,
        personViewModel: {
          document: this.document,
          fullName: this.fullName,
          phone: this.phone,
          isCompany: false,
          email: this.email,
          addressViewModel: {
            postalCode: this.address.PostalCode,
            state: this.address.State,
            city: this.address.City,
            street: this.address.Street,
            number: this.address.Number,
            complement: this.address.Complement,
            neighborhood: this.address.Neighborhood,
            googleAddress: this.address.GoogleAddress
          }
        }
      };
      this.edit = true;
      this.showeditSucessMessage = false;

      var isAgent = localStorage.getItem("is_agent");

      if (isAgent == "true") {
        this.authService
          .editAgent(profile)
          .then(this.editCallBack)
          .catch(this.editCatch);
      } else {
        this.authService
          .editUser(profile)
          .then(this.editCallBack)
          .catch(this.editCatch);
      }
    },
    editCallBack() {
      this.showeditMessage = true;
      this.editMessage = "Cadastro atualizado com sucesso!";
    },
    editCatch() {
      this.showeditMessage = true;
      this.editMessage =
        "Ops! Deu erro, infelizmente tivemos problemas ao editar, entre em contato com nosso suporte ou tente novamente mais tarde";
    },
    fillFieldsWithprofileDataCallback(data) {
      this.profileData = data;

      this.email = this.profileData.email;
      this.document = this.profileData.personViewModel.document;
      this.fullName = this.profileData.personViewModel.fullName;
      this.phone = this.profileData.personViewModel.phone;
      this.address = {
        GoogleAddress: this.profileData.personViewModel.addressViewModel
          .googleAddress,
        PostalCode: this.profileData.personViewModel.addressViewModel
          .postalCode,
        Neighborhood: this.profileData.personViewModel.addressViewModel
          .neighborhood,
        Street: this.profileData.personViewModel.addressViewModel.street,
        Number: this.profileData.personViewModel.addressViewModel.number,
        Complement: this.profileData.personViewModel.addressViewModel
          .complement,
        City: this.profileData.personViewModel.addressViewModel.city,
        State: this.profileData.personViewModel.addressViewModel.state
      };

      if (
        JSON.parse(localStorage.getItem("name")) != this.fullName ||
        JSON.parse(localStorage.getItem("email"))
      ) {
        localStorage.removeItem("name");
        localStorage.removeItem("email");
      }
    },
    handleData: function(e) {
      [
        this.address.GoogleAddress,
        this.address.PostalCode,
        this.address.Neighborhood,
        this.address.Street,
        this.address.Number,
        this.address.Complement,
        this.address.City,
        this.address.State
      ] = e;
    },
    loadProfile() {
      if (this.loading) return;
      this.loadingCount = true;

      var isAgent = localStorage.getItem("is_agent");

      if (isAgent == "true") {
        this.authService
          .getLoggedAgent()
          .then(this.fillFieldsWithprofileDataCallback)
          .finally(() => (this.loadingCount = false));
      } else {
        this.authService
          .getLoggedUser()
          .then(this.fillFieldsWithprofileDataCallback)
          .finally(() => (this.loadingCount = false));
      }
    },
    placechanged(formattedPlace) {
      this.profilePostalCode = formattedPlace.postalCode || "";
      this.profileStreet = formattedPlace.street || "";
      this.profileNumber = formattedPlace.number || "";
      this.profileNeighborhood = formattedPlace.neighborhood || "";
      this.profileCity = formattedPlace.city || "";
      this.profileState = formattedPlace.state || "";
    },
    confirmSuccessMessage() {
      this.showeditSucessMessage = false;
      this.$router.go();
    },
    confirmFailMessage() {
      this.showeditFailMessage = false;
      this.$router.go();
    },
    validatedocument() {
      if (!this.document) return "Preencha o documento";
      if (!CommonHelper.validateCPF(this.document)) return "CPF inválido";
      return true;
    },
    validatefullName() {
      if (!this.fullName) return "Preencha o nome";
      if (!this.agentFullName)
        this.agentFullName = this.fullName;

      if (CommonHelper.wordCount(this.agentFullName) < 2)
        return "Informe seu Nome completo";

      return true;
    },
    validatephone() {
      if (!this.phone) return "Preencha o celular";
      if (!CommonHelper.validateCellPhone(this.phone))
        return "Celular Inválido";
      return true;
    },
    validateEmail() {
      this.email = this.email.trim();
      if (!this.email) return "Preencha o e-mail";
      if (!CommonHelper.validateEmail(this.email)) return "E-mail inválido";
      return true;
    },
    goToAgentManagement() {
      this.$router.push({ name: Routes.app.AgentsManagement });
    },
    goToPreviousPage() {
      history.back();
    },
  }
};
</script>